var _templateObject, _templateObject2, _templateObject3;
function _taggedTemplateLiteral(strings, raw) { if (!raw) { raw = strings.slice(0); } return Object.freeze(Object.defineProperties(strings, { raw: { value: Object.freeze(raw) } })); }
import React, { useEffect, useLayoutEffect, useState } from "react";
import { FormattedMessage } from 'react-intl';
import defaultClasses from './cookieConsent.css';
import Icon from "../Icon";
import { X } from 'react-feather';
import ChildrenPopup from "../ChildrenPopup";
import { gql, useQuery, useMutation } from '@apollo/client';
import { BrowserPersistence } from '@magento/peregrine/lib/util';
import { useAppContext } from "@magento/peregrine/lib/context/app";
import Checkbox from "../CheckboxForm";
import isPrerenderUserAgent from "../../util/isPrerenderUserAgent";
var storage = new BrowserPersistence();
var GET_BAR_INFORMATION = gql(_templateObject || (_templateObject = _taggedTemplateLiteral(["\n    query getCookieBar {\n        getAmCookieBar {\n            amCookieBarType\n            buttons {\n                btnColor\n                btnColorHover\n                btnName\n                btnOrder\n                btnTextColor\n                btnTextColorHover\n                btnType\n            }\n            barLocation\n            firstShowProcess\n            isCookieBarEnabled\n            isCookiePolicyAllowed\n            isDeclineEnabled\n            policyText\n        }\n    }\n"])));
var GET_BAR_GROUPS = gql(_templateObject2 || (_templateObject2 = _taggedTemplateLiteral(["\n    query getCookieBar {\n        getAmCookieGroups {\n            description\n            id\n            is_enabled\n            is_essential\n            name\n            sort_order\n        }\n    }\n"])));

//comma separated ids in a string
var SET_BAR_COOKIE_GROUPS = gql(_templateObject3 || (_templateObject3 = _taggedTemplateLiteral(["\n    mutation setBarCookieGroups($group_ids: String!) {\n        logAmCookieConsent(input: { group_ids: $group_ids }) {\n            message\n            success\n        }\n    }\n"])));
var CookieConsent = () => {
  var barShownEarlier = storage.getItem('cookies-bar-shown');
  var [isConsentShown, setConsentShown] = useState(!barShownEarlier);
  var [isPopupShown, setPopupShown] = useState(false);
  var [, {
    setPreferenceCookies
  }] = useAppContext();
  var {
    data: informationData
  } = useQuery(GET_BAR_INFORMATION, {
    skip: barShownEarlier
  });
  var {
    data: groupData
  } = useQuery(GET_BAR_GROUPS, {
    skip: barShownEarlier
  });
  var [setMagentoCookiesMutation] = useMutation(SET_BAR_COOKIE_GROUPS, {
    skip: barShownEarlier
  });
  var barInformation = (informationData === null || informationData === void 0 ? void 0 : informationData.getAmCookieBar) && informationData.getAmCookieBar[0];
  var barCookieGroups = groupData === null || groupData === void 0 ? void 0 : groupData.getAmCookieGroups;
  var barCookieGroupsShown = barCookieGroups && barCookieGroups.length;
  var barButtons = barInformation === null || barInformation === void 0 ? void 0 : barInformation.buttons;
  var acceptButtonData = barButtons === null || barButtons === void 0 ? void 0 : barButtons.find(el => el.btnType === 'accept');
  var popupCreatives = document.getElementById('attentive_overlay');

  // eslint-disable-next-line react-hooks/exhaustive-deps
  var overrideZIndex = () => {
    return setTimeout(() => popupCreatives.style['z-index'] = 200, 1000);
  };
  useEffect(() => {
    if (popupCreatives && isConsentShown) {
      overrideZIndex();
      window.addEventListener('resize', overrideZIndex);
      return () => {
        window.removeEventListener('resize', overrideZIndex);
      };
    }
  }, [popupCreatives, isConsentShown, overrideZIndex]);
  useEffect(() => {
    if (barInformation) {
      if (barInformation.isCookieBarEnabled && barInformation.isCookiePolicyAllowed) {
        setConsentShown(true);
      }
    }
  }, [barInformation]);
  var setCookiesInMagento = function () {
    var agreedCookies = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : [];
    var necessaryGroups = barCookieGroups.filter(el => el.is_essential);
    var necessaryGroupIds = necessaryGroups.map(el => el.id);
    var cookieGroups = [...necessaryGroupIds, ...agreedCookies];

    //filter duplicates, will leave only same elements of same index,
    var cookieGroupsFiltered = cookieGroups.filter((el, index) => cookieGroups.findIndex(it => it == el) === index);

    //group to be string
    var cookieGroupsFilteredString = cookieGroupsFiltered.join(',');
    setMagentoCookiesMutation({
      variables: {
        group_ids: cookieGroupsFilteredString
      }
    });
    return cookieGroupsFiltered;
  };
  var acceptAllClick = () => {
    var allGroupIds = barCookieGroups === null || barCookieGroups === void 0 ? void 0 : barCookieGroups.map(el => el.id);
    setPreferenceCookies(allGroupIds);
    setCookiesInMagento(allGroupIds);
    setPopupShown(false);
    setConsentShown(false);
  };
  var acceptNecessaryClick = () => {
    var necessaryGroupIds = barCookieGroups === null || barCookieGroups === void 0 ? void 0 : barCookieGroups.filter(el => el.is_essential).map(el => el.id);
    setPreferenceCookies(necessaryGroupIds);
    setCookiesInMagento(necessaryGroupIds);
    setPopupShown(false);
    setConsentShown(false);
  };
  if (!barInformation || barShownEarlier) {
    return null;
  }
  return /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement(CookiePreferencesPopup, {
    barCookieGroups: barCookieGroups,
    isPopupShown: isPopupShown,
    setPopupShown: setPopupShown,
    isConsentShown: isConsentShown,
    setConsentShown: setConsentShown,
    setCookiesInMagento: setCookiesInMagento
  }), /*#__PURE__*/React.createElement("div", {
    id: "cookie_preference_root",
    className: "".concat(defaultClasses.root, " ").concat(isConsentShown ? defaultClasses.shown : "", " ").concat(isPrerenderUserAgent ? defaultClasses.prerenderHidden : null)
  }, /*#__PURE__*/React.createElement("div", {
    className: defaultClasses.body
  }, /*#__PURE__*/React.createElement("div", {
    className: defaultClasses.content
  }, /*#__PURE__*/React.createElement("p", {
    className: defaultClasses.policyText,
    dangerouslySetInnerHTML: {
      __html: barInformation.policyText
    }
  }), /*#__PURE__*/React.createElement("div", {
    className: defaultClasses.buttons
  }, barCookieGroupsShown ? /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement("button", {
    className: defaultClasses.acceptAllBtn,
    onClick: acceptAllClick
  }, /*#__PURE__*/React.createElement("p", null, acceptButtonData === null || acceptButtonData === void 0 ? void 0 : acceptButtonData.btnName))) : /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement("button", {
    className: defaultClasses.acceptAllBtn,
    onClick: acceptNecessaryClick
  }, /*#__PURE__*/React.createElement("p", null, "Accept Only Necessary Cookies"))))))));
};
var CookiePreferencesPopup = props => {
  var {
    barCookieGroups,
    isPopupShown,
    setPopupShown,
    setConsentShown,
    setCookiesInMagento
  } = props;
  var [{
    preferenceCookiesEnabled
  }, {
    setPreferenceCookies
  }] = useAppContext();
  var [tempPreferencesSelection, setTempPreferencesSelection] = useState(preferenceCookiesEnabled || []);
  var savePreferences = () => {
    var cookiesToSet = setCookiesInMagento(tempPreferencesSelection);
    setPreferenceCookies(cookiesToSet);
    setPopupShown(false);
    setConsentShown(false);
  };
  return /*#__PURE__*/React.createElement(ChildrenPopup, {
    visiblePopup: isPopupShown
  }, /*#__PURE__*/React.createElement("div", {
    className: defaultClasses.popupContainer
  }, /*#__PURE__*/React.createElement("div", {
    className: defaultClasses.closeBtn,
    onClick: () => setPopupShown(false)
  }, /*#__PURE__*/React.createElement(Icon, {
    src: X,
    size: 40
  })), /*#__PURE__*/React.createElement("div", {
    className: defaultClasses.popupBody
  }, /*#__PURE__*/React.createElement("h2", {
    className: defaultClasses.popupTitle
  }, /*#__PURE__*/React.createElement(FormattedMessage, {
    id: 'cookieConsent.popupTitle',
    defaultMessage: 'Please select your cookie group'
  })), /*#__PURE__*/React.createElement("div", {
    className: defaultClasses.popupCookieGroups
  }, barCookieGroups === null || barCookieGroups === void 0 ? void 0 : barCookieGroups.map(item => {
    var isNecessary = item.is_essential;
    var isIncluded = tempPreferencesSelection.includes(item.id);
    var switchCookieSelection = () => {
      if (isNecessary) {
        return null;
      }

      //if an element is already in list, delete it
      if (isIncluded) {
        var newArray = [...tempPreferencesSelection];
        newArray.splice(newArray.findIndex(el => el === item.id), 1);
        setTempPreferencesSelection(newArray);
        //otherwise add it
      } else {
        var _newArray = [...tempPreferencesSelection, item.id];
        setTempPreferencesSelection(_newArray);
      }
    };
    return /*#__PURE__*/React.createElement("div", {
      className: defaultClasses.popupCookieGroup
    }, /*#__PURE__*/React.createElement("div", {
      className: "".concat(defaultClasses.popupGroupTitleSection, " ").concat(isNecessary ? defaultClasses.isNecessary : '')
    }, /*#__PURE__*/React.createElement(Checkbox, {
      checked: isNecessary || isIncluded,
      disabled: isNecessary,
      onClick: switchCookieSelection,
      iconSize: 12,
      iconWidth: 5
    }), /*#__PURE__*/React.createElement("h3", {
      className: defaultClasses.popupGroupTitle,
      onClick: switchCookieSelection
    }, item.name)), /*#__PURE__*/React.createElement("p", {
      className: defaultClasses.popupGroupDescription,
      dangerouslySetInnerHTML: {
        __html: item.description
      }
    }));
  })), /*#__PURE__*/React.createElement("div", {
    className: defaultClasses.popupButtons
  }, /*#__PURE__*/React.createElement("button", {
    className: defaultClasses.saveBtn,
    onClick: savePreferences
  }, /*#__PURE__*/React.createElement(FormattedMessage, {
    id: 'cookieConsent.saveMyChoice',
    defaultMessage: 'Save my choice'
  }))))));
};
export default CookieConsent;